<template>
  <el-table-column :label="label" :prop="prop" class-name="route-code" :sortable="sortable">
    <template slot-scope="scope"  v-if='scope.row.regist_type === "0"'>
      <i class="el-icon-check"></i>
      <!-- <el-tag>
        補
      </el-tag> -->
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '補正'
    },
    prop: {
      type: String,
      default: 'regist_type'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.regist_type {
      width: 6em;
    }
  }
  // .el-tag {
  //   width: 2.5em;
  //   text-align:center;
  //   color: #409eff;
  //   background-color: #ecf5ff;
  //   border-color: #d9ecff;
  //   font-weight: bold;
  // }
  i.el-icon-check {
    font-size: 1.3em;
  }
}
</style>
